module.exports = __webpack_public_path__ + "static/media/sale-eth-mobile.3e3da649.png";